// extracted by mini-css-extract-plugin
module.exports = {"container":"_adcecdf","listContainer":"_da0c689d","footer":"_495b64bd","preferencesLink":"_d14c370","sorryMessage":"_81ab3096"};